<template>
  <v-card>
    <v-form
      class="auth"
      v-show="!pending_for_sync"
      @submit="submitLoginForm"
      v-model="form_valid"
      :lazy-validation="false"
      ref="form"
    >
      <v-container fluid grid-list-md>
        <v-layout wrap>
          <v-flex xs12 class="mb-1">
            <v-text-field
              :label="input_label"
              v-model="phone_or_email"
              :rules="rules.phone_or_email"
              :error="input_has_errors"
              :hide-details="false"
              :error-messages="input_error_messages"
              filled
              light
              background-color="#fff"
              v-bind="credential_props"
              :height="32"
            ></v-text-field>

            <div v-if="mode == 'sign_up' && input_is_phone">
              <toc v-model="accepted" :rules="rules.accepted"></toc>
            </div>
          </v-flex>

          <v-flex xs12>
            <v-text-field
              v-model="password"
              :rules="rules.password"
              :append-icon="show_password ? 'mdi-eye-off' : 'mdi-eye'"
              :type="show_password ? 'text' : 'password'"
              :error="hasError('password')"
              :error-messages="getError('password')"
              @input="unsetError('password')"
              :label="password_label"
              @click:append="show_password = !show_password"
              filled
              light
              background-color="#fff"
              :height="32"
              v-bind="password_props"
            >
              <template v-slot:progress>
                <v-progress-linear
                  v-if="passwordStrength != null && mode == 'sign_up'"
                  :value="passwordStrength"
                  :color="passwordStrengthColor"
                  absolute
                  height="4"
                  style="margin-top:1px;left:4px;right:4px;width:auto;border-radius:2px;"
                ></v-progress-linear>
              </template>
            </v-text-field>

            <!-- <div v-if="mode == 'sign_up'">
              <toc v-model="accepted" :rules="rules.accepted"></toc>
            </div>-->

            <div v-if="mode == 'sign_in'">
              <!-- <v-btn
                v-if="!pasword_reset_sent"
                text
                block
                color="secondary"
                :loading="reseting_password"
                @click="resetPassword"
              >{{ trans('app.reset_password_link') }}</v-btn>-->
              <div class="text-center pb-2" v-if="!pasword_reset_sent">
                <a
                  style="font-size: 85%"
                  href="#"
                  @click.stop="resetPassword"
                >{{ trans('app.reset_password_link') }}</a>
                <v-progress-circular
                  v-if="reseting_password"
                  indeterminate
                  color="primary"
                  size="20"
                  width="2"
                  class="mx-3"
                ></v-progress-circular>
              </div>

              <v-alert
                :value="pasword_reset_sent"
                :dismissible="false"
                type="success"
                :dense="true"
                :outlined="true"
              >
                <span>{{ trans('app.reset_password_sent') }}</span>
              </v-alert>
            </div>
          </v-flex>

          <v-flex xs12 class="mb-3" v-if="waiting_confirmation">
            <v-text-field
              v-model="confirmation_code"
              :label="verification_label"
              :error="hasError('confirmation_code')"
              :error-messages="getError('confirmation_code')"
              @input="unsetError('confirmation_code')"
              outlined
              :height="32"
              v-bind="verification_props"
            ></v-text-field>
          </v-flex>

          <v-flex xs12>
            <v-btn
              v-if="waiting_confirmation"
              large
              block
              dark
              color="primary"
              @click="verifySmsCode"
              type="submit"
            >
              <span>{{ trans('app.auth_verify_sms') }}</span>
            </v-btn>
            <v-flex xs12 v-if="!(input_is_email || input_is_phone) && mode == 'sign_up'">
              <toc
                v-if="!(input_is_email || input_is_phone) && mode == 'sign_up'"
                v-model="accepted"
                :rules="rules.accepted"
              ></toc>
            </v-flex>
            <v-btn
              v-if="!waiting_confirmation"
              large
              block
              rounded
              :loading="loading"
              type="submit"
              color="primary"
              depressed
            >
              <v-icon size="22" left v-if="input_is_email">mdi-email</v-icon>
              <v-icon size="22" left v-if="input_is_phone">mdi-phone</v-icon>
              <span>{{ submit_label }}</span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
      <div class="py-1 text-center">
        <span style="font-size: 85%">{{ trans('app.or') }}</span>
      </div>
      <v-container fluid grid-list-md>
        <v-layout wrap>
          <v-flex xs12 class="mb-2">
            <v-btn large block @click="signInWithFacebook" rounded outlined color="grey lighten-2">
              <v-icon size="22" color="#3b5998" left>mdi-facebook-box</v-icon>
              <span style="color: #3b5998">{{ facebook_label }}</span>
            </v-btn>
          </v-flex>

          <v-flex xs12>
            <v-btn large block @click="signInWithGoogle" rounded outlined color="grey lighten-2">
              <v-icon size="22" color="#DB4437" left>mdi-google</v-icon>
              <span style="color: #DB4437">{{ google_label }}</span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
    <div id="recaptcha-container"></div>

    <v-container fluid v-if="pending_for_sync">
      <div class="d-flex flex-column">
        <div>
          <div
            class="mb-3 text-center"
          >{{ trans('user.sync_account_message', { email: pending_for_sync.email }) }}</div>

          <div class="mb-3 text-center">{{ trans('user.sync_account_message_sub') }}</div>

          <v-divider class="mb-3"></v-divider>

          <div v-for="(method,i) in pending_for_sync.methods">
            <div class="mb-3" v-if="method == 'facebook.com'">
              <div
                class="mb-3 font-weight-bold text-center"
              >{{ trans(`user.sync_account_prompt_${ pending_for_sync.provider }`) }}</div>
              <v-btn dark large color="#3b5998" block @click="signInWithFacebookAndSync">
                <v-icon size="22" left>mdi-facebook-box</v-icon>
                <span>{{ facebook_label }}</span>
              </v-btn>
            </div>

            <div class="mb-3" v-else-if="method == 'google.com'">
              <div
                class="mb-3 font-weight-bold text-center"
              >{{ trans(`user.sync_account_prompt_${ pending_for_sync.provider }`) }}</div>
              <v-btn dark large color="#DB4437" block @click="signInWithGoogleAndSync">
                <v-icon size="22" left>mdi-google</v-icon>
                <span>{{ google_label }}</span>
              </v-btn>
            </div>

            <div class="mb-3" v-else-if="method == 'password'">
              <div
                class="mb-3 font-weight-bold text-center"
              >{{ trans(`user.sync_account_prompt_${ pending_for_sync.provider }`) }}</div>
              <div>
                <v-text-field
                  v-model="password"
                  :rules="rules.password"
                  :append-icon="show_password ? 'mdi-eye-off' : 'mdi-eye'"
                  :type="show_password ? 'text' : 'password'"
                  :error="hasError('password')"
                  :error-messages="getError('password')"
                  @input="unsetError('password')"
                  :label="password_label"
                  @click:append="show_password = !show_password"
                  outlined
                  :height="32"
                  v-bind="password_props"
                ></v-text-field>
              </div>
              <div>
                <v-btn
                  large
                  block
                  color="primary"
                  :loading="loading"
                  @click="signInWithPasswordAndSync"
                  type="button"
                >
                  <v-icon size="22" left v-if="input_is_email">mdi-email</v-icon>
                  <span>{{ trans(`app.sign_in_email`) }}</span>
                </v-btn>
              </div>
            </div>
          </div>

          <div v-if="hasError('sync')" class="text-center error--text">{{ getError('sync') }}</div>
        </div>

        <div class="mt-3">
          <v-btn block text color="secondary" @click="cancelSync">{{ trans('app.cancel') }}</v-btn>
        </div>
      </div>
    </v-container>
  </v-card>
</template>

<script>
import firebase from "../firebase";
import { mapGetters, mapActions, mapState } from "vuex";
import owasp from "owasp-password-strength-test";
import Toc from "./auth/Toc";

let regex_email = new RegExp(
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
);
let regex_phone = new RegExp(
  /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/i
);

export default {
  components: {
    Toc
  },

  props: {
    mode: {
      type: String,
      default: "sign_in",
      validator: value => ["sign_in", "sign_up"].indexOf(value) !== -1
    }
  },

  data: () => ({
    email: null,
    password: null,
    phone_number: null,
    show_password: false,
    confirmation_code: null,
    input_buffer: "",
    accepted: false,
    form_valid: false,
    pending_social: null
  }),

  computed: {
    ...mapState("auth", {
      authenticated: "authenticated",
      loading: "attempting",
      waiting_confirmation: "waiting_confirmation",
      reseting_password: "reseting_password",
      pasword_reset_sent: "pasword_reset_sent",
      pending_for_sync: "pending_for_sync"
    }),
    ...mapGetters({
      getError: "errors/get",
      hasError: "errors/has"
    }),

    input_has_errors: function() {
      return (
        this.hasError("email") == true || this.hasError("phone_number") == true
      );
    },

    input_error_messages: function() {
      if (this.hasError("email")) return this.getError("email");
      if (this.hasError("phone_number")) return this.getError("phone_number");
      return null;
    },

    input_is_email: function() {
      return regex_email.test(this.phone_or_email);
    },

    input_is_phone: function() {
      return regex_phone.test(this.phone_or_email);
    },

    input_label: function() {
      if (this.input_is_email) return this.trans("app.enter_email");
      if (this.input_is_phone) return this.trans("app.enter_phone_number");
      return this.trans("app.enter_email_or_phone_number");
    },

    submit_label: function() {
      if (this.input_is_email)
        return this.trans(`app.${this.$props.mode}_email`);
      if (this.input_is_phone)
        return this.trans(`app.${this.$props.mode}_phone_number`);
      return this.trans(`app.${this.$props.mode}`);
    },

    google_label: function() {
      return this.trans(`app.${this.$props.mode}_google`);
    },

    facebook_label: function() {
      return this.trans(`app.${this.$props.mode}_facebook`);
    },

    password_label: function() {
      return this.trans(`app.enter_password`);
    },

    verification_label: function() {
      return this.trans(`app.verification_code`);
    },

    accepted_label: function() {
      return this.trans(`app.accept_terms`);
    },

    password_props: function() {
      if (this.mode == "sign_up") {
        return {
          loading: this.password != null,
          hint: `Password strength: ${Math.round(this.passwordStrength)}%`,
          persistentHint: true
        };
      }
      return {};
    },

    credential_props: function() {
      let hint = this.trans(`app.email_or_phone_number_hint`);
      if (this.input_is_email) {
        hint = this.trans(`app.email_hint`);
      }
      if (this.input_is_phone) {
        hint = this.trans(`app.phone_number_hint`);
      }
      return {
        hint: hint,
        persistentHint:
          this.input_is_email || this.input_is_phone ? true : false
      };
    },

    verification_props: function() {
      return {
        hint: this.trans(`app.verification_code_hint`),
        persistentHint: true
      };
    },

    input_is_provably_valid: function() {
      return this.input_is_email || this.input_is_phone;
    },

    phone_or_email: {
      get: function() {
        return this.input_buffer;
      },
      set: function(input) {
        if (regex_phone.test(input)) {
          let start_digit = new RegExp(/^(\d)/i);
          if (start_digit.test(input)) {
            input = input.replace(/^(\d)/i, "+$1");
            this.input_buffer = input.replace(/^(\d)/i, "+$1");
          }
          this.phone_number = input;
          this.email = null;
          this.password = null; // !
        } else if (regex_email.test(input)) {
          this.email = input;
          this.phone_number = null;
        } else {
          this.email = null;
          this.phone_number = null;
        }

        // to buffer
        this.input_buffer = input;

        this.unsetError("email");
        this.unsetError("phone_number");

        // on change reset verification
        this.cancelConfirm();
      }
    },

    passwordStrength: function() {
      owasp.config({
        allowPassphrases: false,
        maxLength: 32,
        minLength: 6,
        minOptionalTestsToPass: 2
      });
      let password = this.password || "";
      let passes = owasp.test(password).passedTests.length;
      if (password.length < 1) return 0;
      return (passes * 100) / 7;
    },

    passwordStrengthColor: function() {
      var color = "red";
      if (this.passwordStrength >= 66) color = "orange";
      if (this.passwordStrength >= 99) color = "green";
      return color;
    },

    rules: function() {
      let rules = {
        password: [() => true],
        phone_or_email: [() => true],
        accepted: [() => true]
      };

      if (this.input_is_email) {
        rules.password = [() => !!this.password || "Password is required"];
        rules.phone_or_email = [
          () => !!this.email || "Phone number or email address is required"
        ];
      }
      if (this.input_is_phone) {
        rules.phone_or_email = [
          () =>
            !!this.phone_number || "Phone number or email address is required"
        ];
      }
      if (this.mode == "sign_up") {
        rules.accepted = [
          () => this.accepted == true || "You must agree to continue!"
        ];
      }

      return rules;
    }
  },

  methods: {
    ...mapActions("auth", {
      login: "login",
      confirm: "confirm",
      register: "register",
      sendPasswordResetEmail: "sendPasswordResetEmail",
      cancelConfirm: "cancelConfirm",
      cancelSync: "cancelSync"
    }),
    ...mapActions("errors", {
      unsetError: "unset"
    }),

    signInWithFacebook: function() {
      if (this.mode == "sign_up" && !this.accepted) {
        this.pending_social = new Promise((resolve, reject) => {
          this.$watch("accepted", v => {
            if (v == true) resolve(true);
          });
        });
        this.$refs.form.validate();
      }

      if (this.pending_social) {
        this.pending_social.then(() => {
          this.login({ provider: "facebook" });
        });
        return;
      }

      return this.login({ provider: "facebook" });
    },

    signInWithGoogle: function() {
      if (this.mode == "sign_up" && !this.accepted) {
        this.pending_social = new Promise((resolve, reject) => {
          this.$watch("accepted", v => {
            if (v == true) resolve(true);
          });
        });
        this.$refs.form.validate();
      }

      if (this.pending_social) {
        this.pending_social.then(() => {
          this.login({ provider: "google" });
        });
        return;
      }

      return this.login({ provider: "google" });
    },

    submitLoginForm: function(e) {
      e.preventDefault();
      if (this.loading) return;
      if (!this.form_valid) return;
      if (this.waiting_confirmation) {
        return this.verifySmsCode();
      } else {
        // +
        if (!this.input_is_email && !this.input_is_phone) return;
        return this.signInWithPhoneOrPassword();
      }
    },

    signInWithPhoneOrPassword: function() {
      if (this.input_is_email) {
        if (this.$props.mode == "sign_in") {
          this.signInWithPassword();
        } else {
          this.signUpWithPassword();
        }
      }
      if (this.input_is_phone) {
        this.signInWithPhoneNumber();
      }
    },

    signInWithPassword: function() {
      this.login({
        provider: "password",
        email: this.email,
        password: this.password
      });
    },

    signInWithFacebookAndSync: function() {
      this.login({
        provider: "facebook",
        sync: true
      });
    },

    signInWithGoogleAndSync: function() {
      this.login({
        provider: "google",
        sync: true
      });
    },

    signInWithPasswordAndSync: function() {
      this.login({
        provider: "password",
        email: this.pending_for_sync.email,
        password: this.password,
        sync: true
      });
    },

    signUpWithPassword() {
      this.register({
        email: this.email,
        password: this.password
      });
    },

    signInWithPhoneNumber: function() {
      this.login({
        provider: "phone",
        phone_number: this.phone_number
      });
    },

    verifySmsCode: function() {
      this.confirm(this.confirmation_code);
    },

    resetFields: function() {
      this.email = null;
      this.password = null;
      this.phone_number = null;
      this.phone_or_email = null;
      this.errors = null;
      this.accepted = false;
      this.unsetErrors();
    },

    resetPassword: function() {
      this.sendPasswordResetEmail(this.email);
    },

    unsetErrors: function() {
      this.unsetError("email");
      this.unsetError("phone_number");
      this.unsetError("accepted");
    }
  },

  mounted: function() {
    this.unsetErrors();

    this.$store.subscribe(({ type, payload }, state) => {
      if (type == "auth/login" && payload.authenticated == true) {
        this.$emit("login", state);
        this.resetFields();
      }
      if (type == "auth/logout") {
        this.resetFields();
      }
      if (type == "errors/put") {
        this.$forceUpdate();
      }
    });
  }
};
</script>

<style lang="scss">
/*.auth {
  &
    .theme--dark.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background: rgba(0, 0, 0, 0.3) !important;
  }
}*/
</style>